import React from 'react'
import AdminCustomButton from './AdminCustomButton'
import MessageHeading from './MessageHeading'
import { Link } from "react-router-dom";
import MessageBox from './MessageBox';

const AdminSaveHeader = ({ heading, saveText, saveMethod, className, type, hideButton, loading, buttonId, link }) => {
    return (
        <div className={`d-flex align-items-center flex-wrap px-md-0 px-3 mb-3 pb-3 ${className || ''}`}>
            <div className={`col-sm-8 col-12 `}>
                <MessageHeading text={heading} className="admin-title pb-sm-0  text-md-start" noMargin />
            </div>
            <div className={`col-sm-4 col-12 d-flex align-items-center justify-content-end mt-md-0 mt-3 gap-3`}>
                {link &&
                    <Link className="theme-text-color table-heading d-flex  align-items-center" target="_blank" to={link}>
                        <MessageBox text="Preview" classname='ms-2 theme-text-color button-bg-color theme-button-text-color admin-button-text  rounded-3  py-2 px-3' />
                    </Link>
                }
                {!hideButton && <AdminCustomButton saveMethod={saveMethod} saveText={saveText} loading={loading} type={type} id={buttonId} />}
            </div>
        </div>
    )
}

export default AdminSaveHeader